export type ArchivesState = {
  discoverElectronicSafeDialogIsOpen: boolean
  listSearchPending: boolean
  listSearchData: Array<ArchiveDocument>
  listSearchDataCount: number
  config: ArchiveConfig | null
  configPending: boolean
  getArchiveRightsPending: boolean
  currentArchiveRights: ArchiveRights | {}
  sendArchivesPending: boolean
  shareArchivesPending: boolean
  muteArchivingWarning: boolean
  uploadArchivePendingIds: Array<number>
  uploadArchiveErrors: Array<Error>
  postArchivePendingIds: Array<number>
  postArchiveErrors: Array<Error>
  selectedDocuments: Array<ArchiveDocument>
  archivesDownloadPending: boolean
}

export const state: ArchivesState = {
  discoverElectronicSafeDialogIsOpen: false,
  listSearchPending: false,
  listSearchData: [],
  listSearchDataCount: 0,
  config: null,
  configPending: false,
  getArchiveRightsPending: false,
  currentArchiveRights: {},
  sendArchivesPending: false,
  shareArchivesPending: false,
  muteArchivingWarning: false,
  uploadArchivePendingIds: [],
  uploadArchiveErrors: [],
  postArchivePendingIds: [],
  postArchiveErrors: [],
  selectedDocuments: [],
  archivesDownloadPending: false,
}
